module.exports = __webpack_public_path__ + "static/media/Logo Hengel.66387f4f.png";